import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_REQUIRED_VERIFICATION_CHANGE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import { ContractSetupVerificationMethodMap } from '@app/store/contract-setup/ContractSetupVerificationMethodMap';

interface verificationRequiredTypes {
  verifications: ContractSetupVerificationMethodMap[];
}

const initialState: verificationRequiredTypes = { verifications: [] };

export default function reducer(
  state: verificationRequiredTypes = initialState,
  action: ContractSetupAction
): verificationRequiredTypes {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
      return initialState;
    case CONTRACT_SETUP_REQUIRED_VERIFICATION_CHANGE:
      return { verifications: action.payload.verifications };
    default:
      return state;
  }
}
